export default () => window.Core.getEmptyWordDocument();